// ATTENTION
//  known issue in JSDOM but won't be resolved: https://github.com/jsdom/jsdom/issues/3492
export const getLocation = (): Location => window.location;
